import React, { useState } from 'react';
import './HomeHeader.css';
import logo from '../../assets/logo.jpg';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

const HomeHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log('Search query:', searchQuery);
    };

    return (
        <header className="hn-home-header">
            <div className="hn-home-header-container">
                <Link to="/" className="hn-home-logo">
                    <img src={logo} alt="Logo" className="hn-home-logo-img" />
                </Link>

                <button className="hn-home-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
                    <span className="hn-home-menu-icon"></span>
                </button>

                <nav className={`hn-home-nav-head ${isMenuOpen ? 'hn-home-nav-open' : ''}`}>
                    <Link to="/" className="hn-home-nav-link">
                        TRANG CHỦ
                    </Link>
                    <div className="hn-home-nav-link hn-home-dropdown">
                        <Link to="/product" className="hn-home-dropdown-toggle">
                            SẢN PHẨM
                        </Link>
                        <div className="hn-home-dropdown-menu">
                            <a href="/noithat" className="hn-home-dropdown-item">
                                Nội thất chung cư
                            </a>
                        </div>
                    </div>
                    <a href="/service" className="hn-home-nav-link">
                        DỊCH VỤ
                    </a>
                    <a href="/new" className="hn-home-nav-link">
                        TIN TỨC
                    </a>
                    <Link to="/support" className="hn-home-consult-button">ĐĂNG KÝ TƯ VẤN</Link>
                    {/* Search form for mobile */}
                    <form className="hn-home-search-container hn-home-search-mobile" onSubmit={handleSearch}>
                        <input
                            type="text"
                            className="hn-home-search-input"
                            placeholder="Tìm kiếm..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            aria-label="Search"
                        />
                        <button type="submit" className="hn-home-search-button" aria-label="Search button">
                            <FaSearch className="hn-home-search-icon" />
                        </button>
                    </form>
                </nav>

                {/* Search form for desktop */}
                <form className="hn-home-search-container hn-home-search-desktop" onSubmit={handleSearch}>
                    <input
                        type="text"
                        className="hn-home-search-input"
                        placeholder="Tìm kiếm..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        aria-label="Search"
                    />
                    <button type="submit" className="hn-home-search-button" aria-label="Search button">
                        <FaSearch className="hn-home-search-icon" />
                    </button>
                </form>
            </div>
        </header>
    );
};

export default HomeHeader; 